
    import Pdfh5 from "pdfh5";
    import "pdfh5/css/pdfh5.css";
    import { defineComponent, computed, ComputedRef, reactive,  onMounted} from "vue";
    import {useStore} from "@/store";
    export default defineComponent({
        name: "PdfView",
        setup() {
            let state = reactive({
                pdfh5: null
            });
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            const { reportConfigInfo } = dataInfo.value as any
            onMounted(() => {
                state.pdfh5 = new Pdfh5("#pdf", {
                    pdfurl: reportConfigInfo.serviceGuarantee || ''
                });
            });
            return {
                state
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            }
        }
    });
